var exports = {
  "Nr": "x7f9a0e16--fa5213--card",
  "Zd": "x7f9a0e16--fa5213--form",
  "b1": "x7f9a0e16--fa5213--question",
  "Sl": "x7f9a0e16--fa5213--image",
  "LK": "x7f9a0e16--fa5213--vertically-centered",
  "U": "x7f9a0e16--fa5213--wide",
};

module.exports = exports;
